import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { IqTrendlinesOptimizelyService } from '../state';

@Component({
    selector: 'iq-trendlines-ff-register',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-trendlines-ff-register.component.html',
    styleUrl: './iq-trendlines-ff-register.component.scss',
})
export class IqTrendlinesFfRegisterComponent {
    private _optimizelyService: IqTrendlinesOptimizelyService = inject(
        IqTrendlinesOptimizelyService,
    );
    constructor() {
        this._optimizelyService.init().subscribe();
    }
}
